import type { MouseEvent } from "react"

// Ugly workaround as tanstack is misbehaving. TODO: revisit
export const scrollTopOnClick = (e: MouseEvent<HTMLElement>) => {
  if (e.metaKey || e.ctrlKey) {
    return
  }
  requestAnimationFrame(() => {
    window.scrollTo({ behavior: "smooth", top: 0 })
  })
}

export const scrollIntoViewRef =
  (block: ScrollLogicalPosition = "nearest") =>
  (node: HTMLElement | null) => {
    node?.scrollIntoView({ block })
  }
